import React from "react"
import PropTypes from "prop-types"
import Hero from "../sections/Hero"
import Image from "../common/Image"
import Related from "../sections/Related"
import SmartColour from "../../utils/ColourHandler"
import SmartText from "../../utils/TextHandler"
import Sections from "../sections/Sections"
import OTLink from "../common/otLink"

/********************************
<ThingTemplate />
/********************************
Version: 1
Created: 29 02 2024
Updated: 19 06 2024
Author: Richy Pears
/********************************
These templates are abstracted from
the pages / templates so we don't
repeat layouts when this content is
loaded in
- Front End
- Storyblok editor
- Any alternative languages
/********************************/

const ThingTemplate = ({ data, location }) => {
  if (!data) return null // Escape hatch

  const colour = SmartColour(data.theme)

  return (
    <>
      <Hero
        blok={{
          aspect: data.aspect,
          title: data.title,
          title_colour: data.title_colour,
          title_show: data.title_show,
          ctas: data.ctas,
          image: data.image,
          video: data.video,
          video_mute: data.video_mute,
          theme: colour.background,
        }}
      />
      {(data.type ||
        data.logo?.filename ||
        data.headline ||
        data.description_show === true) && (
        <section className={`py-12 ${colour.classes && colour.classes}`}>
          <div className="container mx-auto px-3">
            <div className="mx-auto w-full md:w-2/3 xl:w-1/2 xxl:w-1/2 text-center flex flex-col gap-4 md:gap-6 justify-center items-center">
              {data.headline && (
                <h1 className="brand-text mb-0">{data.headline}</h1>
              )}
              {data.description && data.description_show === true && (
                <SmartText className="brand-text-large mx-auto brand-remove-last-margin w-full">
                  {data.description}
                </SmartText>
              )}
              <></>
              {data.logo && data.logo?.filename && (
                <Image className="w-48 mx-auto my-0" src={data.logo} />
              )}
              {data.tags && data.tags?.value?.length > 0 && (
                <p className="m-0 text-lg uppercase flex flex-col md:flex-row">
                  {data.tags?.value?.map((node, index) => (
                    <>
                      {index > 0 && (
                        <span className="opacity-50 hidden md:inline mx-2">
                          /
                        </span>
                      )}
                      <span className="font-bold whitespace-nowrap">
                        {node}
                      </span>
                    </>
                  ))}
                </p>
              )}
            </div>
          </div>
        </section>
      )}
      <Sections body={data.body && data.body} location={location} />
      <Related
        blok={data.related && data.related}
        theme="white"
        padding="both"
      />
    </>
  )
}

export default ThingTemplate

ThingTemplate.defaultProps = {
  data: null,
  location: null,
}

ThingTemplate.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}
